import React, { useState, useEffect } from "react";
import { useRouter } from "./../util/router";
import { useUser } from "../util/user";
import MapContent from "./../components/map/MapContent";
import NotFoundPage from "../components/general/NotFound";

function MapPage() {
  const [hasAccess, setHasAccess] = useState(false);
  const router = useRouter();
  const userObj = useUser();

  useEffect(() => {
    if (userObj != null) {
      if (userObj.roles != null && userObj.roles.includes("map:_view"))
        setHasAccess(true);
    }
    else
      router.push("/solar/logout");

  }, [userObj]);
  return hasAccess ? <MapContent /> : <NotFoundPage />;
}

export default MapPage;
